import moment from 'moment-timezone';
import { useMemo } from 'react';

/**
 * Normalize a date range into UTC start/end for backend payload.
 * Ensures start = 00:00:00, end = 23:59:59 in the current timezone.
 */

export const normalizeDateRange = (range) => {
  if (!range?.from || !range?.to) return null;

  return {
    from: moment(range.from).startOf('day').toISOString(),
    to: moment(range.to).endOf('day').toISOString(),
  };
};

export const useIsLabelFilterApplied = ({ dateRange, replyDateRange, replyStatus }) => {
  return useMemo(() => {
    return Boolean(
      (dateRange?.from && dateRange?.to) ||
        (replyDateRange?.from && replyDateRange?.to) ||
        (replyStatus && replyStatus !== '')
    );
  }, [dateRange, replyDateRange, replyStatus]);
};

export const useIsFilterApplied = ({
  dateRange,
  replyDateRange,
  replyStatus,
  emailRecipients,
  selectedEmailAddresses,
  selectedNames,
}) => {
  return useMemo(() => {
    return Boolean(
      (dateRange?.from && dateRange?.to) ||
        (replyDateRange?.from && replyDateRange?.to) ||
        (replyStatus && replyStatus !== '') ||
        (emailRecipients && Object.keys(emailRecipients).length > 0) ||
        (selectedEmailAddresses && selectedEmailAddresses.length > 0) ||
        (selectedNames && selectedNames.length > 0)
    );
  }, [dateRange, replyDateRange, replyStatus, emailRecipients, selectedEmailAddresses, selectedNames]);
};

/**
 * Email validation utility function
 * @param {string} email - The email address to validate
 * @returns {boolean} - Whether the email is valid
 */
export const isValidEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email.trim());
};
